module.exports = __webpack_public_path__ + "static/media/icon-status-at-consignee.fd750ef9.svg";